module.exports = __webpack_public_path__ + "static/media/42x40-12.ef956227.png";